<template>
  <div :class="$style.mfaEnrollmentBox">
    <i :class="[$style.mfaEnrollmentIcon, 'jc-mfa-pending']" />
    <span>Apply an enrollment period of</span>
    <div :class="$style.inputContainer">
      <InputValidator
        :class="{
          [$style.mfaEnrollmentInput]: true,
          [$style.mfaEnrollmentInputWithError]: v2Errors.items.length,
        }"
        :config="{
          errorStyleExceptions: $style.validationError,
          name: 'MFA Enrollment Period',
          validate: 'required|numeric|min_value:1|max_value:365',
          value,
        }"
        @InputValidatorModel="handleValueChange"
      />
    </div>
    <span>days for {{ keyword }}.</span>
  </div>
</template>

<script>
import InputValidator from 'components/FormValidation/InputValidator.vue';

const errorMessage = '* requires value 1-365';

export default {
  name: 'MFAEnrollmentInput',

  components: {
    InputValidator,
  },

  inject: ['$validator'],

  vValidateDict: {
    custom: {
      'MFA Enrollment Period': {
        max_value: errorMessage,
        min_value: errorMessage,
        numeric: errorMessage,
        required: errorMessage,
      },
    },
  },

  props: {
    keyword: {
      type: String,
      default: 'requirement',
    },
    value: {
      type: String,
      required: true,
    },
  },

  mounted() {
    this.$validator.localize('en', this.$options.vValidateDict);
  },

  methods: {
    handleValueChange(newValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>

<style module>
@value (jcOrange, red) from '~css/colors.css';
@value (panelSpeedSm, panelTimingFunction) from '~css/transitions.css';

.mfaEnrollmentBox {
  margin-top: 20px;
}

.mfaEnrollmentIcon {
  color: jcOrange;
  font-size: 17px;
  margin-right: 3px;
}

.inputContainer {
  display: inline-block;
  position: relative;
}

.mfaEnrollmentInput {
  margin: 0 5px;
  text-align: center;
  transition: margin-bottom panelSpeedSm panelTimingFunction;
  width: 45px;
}

.inputContainer .mfaEnrollmentInputWithError {
  margin: 0 0 40%;
}

.inputContainer .mfaEnrollmentInput input {
  text-align: center;
}

.inputContainer .validationError {
  position: absolute;
  top: 105%;
  white-space: nowrap;
}
</style>
